import { TranslationLabels } from '@generated/translation-labels';
import { Stepper } from '../types';

export const stepper: Stepper = [
  {
    step: 'category',
    labelKey: TranslationLabels.myAccountCategoryStep,
  },
  {
    step: 'additional_info',
    labelKey: TranslationLabels.additionalInfoStep,
  },
];
